import React from "react";
import { func } from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button/Button";

const NoMLSModal = ({ closeOptionsModal }) => {
  const handleClick = () => {
    window.open(
      "https://www.brivityknowledge.com/docs/enable-brivity-cma-and-market-reports-for-new-users",
      "_blank",
    );
  };
  return (
    <Modal
      className="tw-flex tw-justify-center tw-items-center"
      dialogClassName="!tw-w-[650px] tw-h-auto"
      contentClassName="tw-w-full tw-h-full"
      backdrop="static"
      show
      onHide={closeOptionsModal}
    >
      <Modal.Header titleClassName="tw-mb-[12px] tw-text-gray-75" title="Market Report Actions" closeButton />

      <Modal.Body>
        <p className="tw-pb-[22px] tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-gray-50">
          Market Reports are one of the best ways to nurture seller leads and your sphere by showing them
          what's going on in the real estate market in their neighborhood.
        </p>
        <div className="tw-flex tw-justify-center tw-border-2 tw-bg-gray-5 tw-py-[24px] tw-px-[4px] tw-border-solid tw-border-gray-10 tw-rounded-[8px]">
          <div className="tw-w-[70%] tw-text-center">
            <div className="tw-text-[18px] tw-font-bold tw-leading-[24px] tw-text-gray-75">
              Not Connected to an MLS
            </div>
            <div className="tw-pt-[24px] tw-text-[14px] tw-font-semibold tw-leading-[22px] tw-text-gray-75">
              You’re almost ready to start using Market Reports! We need a little more info to get started.
            </div>
            <div className="tw-py-[24px] tw-text-[14px] tw-font-semibold tw-leading-[22px] tw-text-gray-75">
              Please start a live chat or contact support at 855-427-4848 to complete the setup for CMA and
              Market Reports.
            </div>
            <Button size="medium" schema="primary" onClick={handleClick}>
              Learn More
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
NoMLSModal.propTypes = {
  closeOptionsModal: func,
};

NoMLSModal.defaultProps = {
  closeOptionsModal: null,
};
export default NoMLSModal;
